/**
 * Las seis rutas creativas de la v1.0 y los casos de uso que las invocan.
 *
 * Son la doctrina del sistema —qué recorrido hace cada tipo de pedido, con qué
 * herramientas y en cuánto tiempo—, no datos operativos. Por eso viven en el
 * código y no en la base: no cambian por proyecto.
 *
 * Portadas literalmente del export de Martín (sha256 cc05a988…).
 */
import type { IconName } from '../components/Icon.tsx';

export interface RutaCreativa {
  readonly code: string;
  readonly name: string;
  readonly tone: 'blue' | 'warn' | 'ok' | 'red';
  readonly tools: readonly string[];
  readonly time: string;
  readonly quality: number;
}

export const RUTAS: Record<string, RutaCreativa> = {
  R1: { code: 'R1', name: 'Landing / Web',        tone: 'blue', tools: ['Figma', 'Magic UI', '21st.dev', 'Webflow'],  time: '3–5 días',    quality: 94 },
  R2: { code: 'R2', name: 'Video / Motion',       tone: 'warn', tools: ['Figma', 'Remotion', 'After Effects'],        time: '5–8 días',    quality: 91 },
  R3: { code: 'R3', name: 'Campaña integral',     tone: 'red',  tools: ['Figma', 'Magic UI', 'Remotion', 'Meta Ads'], time: '2–3 semanas', quality: 96 },
  R4: { code: 'R4', name: 'Sitio institucional',  tone: 'blue', tools: ['Figma', 'Webflow', '21st.dev'],              time: '2–4 semanas', quality: 93 },
  R5: { code: 'R5', name: 'Producto / Dashboard', tone: 'ok',   tools: ['Figma', '21st.dev', 'React'],                time: '2–3 semanas', quality: 92 },
  R6: { code: 'R6', name: 'Presentación',         tone: 'ok',   tools: ['Figma', 'Slides'],                           time: '2–4 días',    quality: 90 },
};

export interface CasoDeUso {
  readonly name: string;
  readonly icon: IconName;
  readonly ruta: RutaCreativa;
}

export const CASOS: readonly CasoDeUso[] = [
  { name: 'Landing Page',           icon: 'layout-grid',    ruta: RUTAS['R1']! },
  { name: 'Sitio institucional',    icon: 'layout-grid',    ruta: RUTAS['R4']! },
  { name: 'Campaña integral',       icon: 'refresh-cw',     ruta: RUTAS['R3']! },
  { name: 'Video corporativo',      icon: 'eye',            ruta: RUTAS['R2']! },
  { name: 'Reel',                   icon: 'eye',            ruta: RUTAS['R2']! },
  { name: 'Dashboard',              icon: 'layout-grid',    ruta: RUTAS['R5']! },
  { name: 'Presentación comercial', icon: 'clipboard-list', ruta: RUTAS['R6']! },
];

/** Verde ≥95, azul ≥90, ámbar por debajo — el semáforo de la v1.0. */
export const colorQS = (q: number) => (q >= 95 ? 'ok' : q >= 90 ? 'blue' : 'warn');

export const EJEMPLOS_PLAYGROUND = [
  'Quiero una landing para un operador logístico',
  'Necesito un reel para redes del depósito',
  'Campaña integral para captar clientes ANMAT',
  'Un dashboard para seguimiento de flota',
  'Una presentación comercial para importadores',
] as const;
